import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Données structurées Schema.org pour pages Réalisation
 * Génère LocalBusiness + Service pour SEO local avancé
 */
const SchemaOrgRealisationSEO = ({ realisation }) => {
  const pageUrl = `https://orion-industrie.eu/realisations/${realisation.slug}`;
  
  // Schema.org Article (pour la réalisation elle-même)
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": realisation.h1 || realisation.title,
    "image": realisation.main_image,
    "datePublished": realisation.published_at || realisation.created_at,
    "dateModified": realisation.updated_at,
    "author": {
      "@type": "Organization",
      "name": "Orion Industrie",
      "url": "https://orion-industrie.eu"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Orion Industrie",
      "logo": {
        "@type": "ImageObject",
        "url": "https://orion-industrie.eu/orion-logo.png"
      }
    },
    "description": realisation.seo_description || realisation.intro,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": pageUrl
    }
  };

  // Schema.org Service (pour le service rendu)
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": realisation.service_type || "Installation d'équipements de quai",
    "provider": {
      "@type": "LocalBusiness",
      "@id": "https://orion-industrie.eu/#organization",
      "name": "Orion Industrie",
      "image": "https://orion-industrie.eu/orion-logo.png",
      "url": "https://orion-industrie.eu",
      "telephone": "+33659452562",
      "email": "gestion@orion-industrie.eu",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "FR",
        "addressRegion": "France"
      },
      "geo": realisation.region ? {
        "@type": "GeoCoordinates",
        "addressCountry": "FR"
      } : undefined,
      "areaServed": {
        "@type": "Country",
        "name": "France"
      },
      "priceRange": "€€",
      "paymentAccepted": "Virement, Chèque",
      "openingHours": "Mo-Fr 08:00-18:00"
    },
    "areaServed": {
      "@type": "City",
      "name": realisation.city,
      "containedIn": realisation.region ? {
        "@type": "AdministrativeArea",
        "name": realisation.region
      } : undefined
    },
    "category": realisation.category,
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "priceSpecification": {
        "@type": "PriceSpecification",
        "priceCurrency": "EUR"
      }
    }
  };

  // Schema.org LocalBusiness (si on veut renforcer le signal local)
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Orion Industrie",
    "image": "https://orion-industrie.eu/orion-logo.png",
    "url": "https://orion-industrie.eu",
    "telephone": "+33659452562",
    "email": "gestion@orion-industrie.eu",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "FR"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": realisation.city
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Équipements de quai",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": `${realisation.service_type || 'Installation'} ${realisation.category}`,
            "description": realisation.seo_description
          }
        }
      ]
    }
  };

  return (
    <Helmet>
      {/* Article Schema */}
      <script type="application/ld+json">
        {JSON.stringify(articleSchema)}
      </script>

      {/* Service Schema */}
      <script type="application/ld+json">
        {JSON.stringify(serviceSchema)}
      </script>

      {/* LocalBusiness Schema (signal géo fort) */}
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
    </Helmet>
  );
};

export default SchemaOrgRealisationSEO;
